import React, { Component } from "react";
// import { BrowserRouter as Router } from "react-router-dom";
import * as Survey from "survey-react";
import { json } from "./survey_json.js";
import GooglePlacesAutoComplete from './GooglePlacesAutoComplete';
import InputTime from './InputTime';
// Firebase App (the core Firebase SDK) is always required and must be listed first
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "survey-react/survey.css";
import "bootstrap/dist/css/bootstrap.css";
import "./App.css";


/* -------------------------------------------------------------------------- */
/*                                  @ Styling                                 */
/* -------------------------------------------------------------------------- */

var fpsRed = "#c23b3b";
var frsRedHover = "#9c2525";
var frsBlue = "#091D3A";
var frsGrey = "#666666";
var defaultThemeColorsSurvey = Survey
    .StylesManager
    .ThemeColors["default"];
    defaultThemeColorsSurvey["$main-color"] = fpsRed;
    defaultThemeColorsSurvey["$main-hover-color"] = frsRedHover;
    defaultThemeColorsSurvey["$text-color"] = frsGrey;

/* ---------------------------- @ Apply ------------------------------------- */
Survey
    .StylesManager
    .applyTheme();


/* Firebase Firestore*/
const firebaseConfig = {
    apiKey: "AIzaSyA3G44Pn0jSGBFAwjuIjfGDrF4rq8RDl-g",
    authDomain: "firefighter-rescue-survey.firebaseapp.com",
    projectId: "firefighter-rescue-survey",
    storageBucket: "firefighter-rescue-survey.appspot.com",
    messagingSenderId: "438263131226",
    appId: "1:438263131226:web:921324e8be87406ce83c63"
  };

firebase.initializeApp(firebaseConfig);

firebase.firestore().enablePersistence();
firebase.auth()
    .signInAnonymously().then(() => {
        //console.log("signed in");
      })
    .catch((error) => {
        console.log(error);
    });


firebase.auth().onAuthStateChanged((user) => {
    if (user) {
        console.log("onAuthStateChanged logged in");
    } else {
        console.log("onAuthStateChanged logged out");
    }
    });

class SurveyComponent extends Component {
  render() {

    GooglePlacesAutoComplete();
    InputTime();

    var survey = new Survey.Model(json);


  var surveyValueChanged = function (sender, options) {
      var el = document.getElementById(options.name);
      if (el) {
          el.value = options.value;
      }
      console.log(options.value);
  };

  var persistToGSheets = function (survey_json) {
    console.log("persistToGSheets");
    var request = new XMLHttpRequest();
    var url = "https://script.google.com/macros/s/AKfycbxWAfRpJmTyKwyXnT4cFXNnDZ6sKMCI_Utupp1uSEYs7koj-fPT5sDUqcHKVkLaz_B0/exec";
    request.open("POST", url, true);
    request.setRequestHeader("Content-Type", "text/plain");
    request.onreadystatechange = function () {
        if (request.readyState === 4 && request.status === 200) {
            console.log("Posted to GSheets");
            return true;
        }
        else
        {
            return false;
        }
    };

    request.send(survey_json);

}

var persistToFireestore = function (survey_json) {
	
    console.log("persistToFireestore");
    const collection = firebase.firestore().collection('surveys');

    const persist = {
        "data" : survey_json
    }

    collection.add(persist);
}


  var surveyCompleted = function (result) {

    const survey_json = JSON.stringify(result.data);

    persistToFireestore(survey_json);
    persistToGSheets(survey_json);
    return true;
};

survey.getAllQuestions().filter(x => x.getType() === "paneldynamic").forEach((element) =>
{
    survey.setVariable("victimDetailCount", element.panelCount);
});


survey.onDynamicPanelAdded.add((sender, options) =>
        {
            console.log("onPanelAdded");
            sender.setVariable("victimDetailCount", options.question.panelCount);
        });

survey.onDynamicPanelRemoved.add((sender, options) =>
        {
            console.log("onPanelRemoved");
            sender.setVariable("victimDetailCount", options.question.panelCount);
        });

/* var scrollToTop = function (result) {

    $([document.documentElement, document.body]).animate({
        scrollTop: $("#sq_118").offset().top
    }, 1000);

    return true;
}; */
 
survey
    .onComplete
    .add(function (sender) {
        console.log(JSON.stringify(sender.data, null, 3));
    });

  return (
  <div className="container">
      <div>
          <Survey.Survey
              model={survey}
              onValueChanged={surveyValueChanged}
              onComplete={surveyCompleted}
          />
      </div>  
  </div>
  );
}
}

export default SurveyComponent;



// WEBPACK FOOTER //
// ./src/SurveyComponent.jsx